<template>
  <div class="card card-custom mt-5">
    <div class="card-header">
      <div class="card-title">
        <h3 class="card-label">Thông tin sản phẩm quan tâm</h3>
      </div>
    </div>
    <div class="card-body">
      <b-row>
        <b-col md="12">
          <Treeselect
            :load-options="onSearchProductChange"
            :multiple="true"
            :async="true"
            :placeholder="'Chọn sản phẩm quan tâm'"
            :cache-options="false"
            :disabled="mode === MODE.VIEW"
            retryText="Thử lại..."
            retryTitle="Nhấp thử lại"
            searchPromptText="Nhập để tìm kiếm..."
            loadingText="Đang tải..."
            noResultsText="Không có kết quả"
            openDirection="bottom"
            @select="onSelectProduct"
            @deselect="onDeselectProduct"
          >
            <label
              slot="option-label"
              slot-scope="{ node, labelClassName }"
              :class="labelClassName"
            >
              <template>
                <div>
                  <b class="text-primary">
                    ( {{ convertPrice(node.raw.sellingPrice) }} )
                  </b>
                  <b
                    :class="
                      node.raw.quantityInStock > 0
                        ? 'text-success'
                        : 'text-danger'
                    "
                  >
                    ( TCB:{{ node.raw.quantityInStock }} )
                  </b>
                  {{ node.raw.name }}
                </div>
              </template>
            </label>
          </Treeselect>

          <!-- Selected Products Table -->
          <div
            v-if="selectedProducts && selectedProducts.length > 0"
            class="mt-4"
          >
            <table class="table table-bordered table-hover">
              <thead>
                <tr>
                  <th class="header-color text-center">Mã sản phẩm</th>
                  <th class="header-color text-center">Sản phẩm</th>
                  <th class="header-color text-center">Giá</th>
                  <th class="header-color text-center">Tồn kho</th>
                  <th class="header-color text-center">Trạng thái</th>
                  <th
                    class="header-color text-center"
                    v-if="mode !== MODE.VIEW"
                  ></th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(product, index) in selectedProducts"
                  :key="`product-${product.id}-${index}`"
                >
                  <td style="width: 8%">
                    <span class="font-weight-bolder">{{
                      product.code || 'N/A'
                    }}</span>
                  </td>
                  <td style="width: 40%">
                    <div>
                      <p class="m-0 font-weight-bolder">
                        {{ product.name || 'N/A' }}
                      </p>
                    </div>
                  </td>
                  <td class="text-right" style="width: 20%">
                    <b class="text-primary">
                      {{
                        product.sellingPrice
                          ? convertPrice(product.sellingPrice)
                          : 'N/A'
                      }}
                    </b>
                  </td>
                  <td class="text-center" style="width: 10%">
                    <b
                      :class="
                        (product.quantityInStock || 0) > 0
                          ? 'text-success'
                          : 'text-danger'
                      "
                    >
                      {{ product.quantityInStock || 0 }}
                    </b>
                  </td>
                  <td class="text-center" style="width: 20%">
                    <Treeselect
                      :value="product.interestStatus"
                      :options="interestStatusOptions"
                      :multiple="false"
                      :placeholder="'Chọn trạng thái'"
                      :cache-options="false"
                      :normalizer="normalizer"
                      :clearable="false"
                      :disabled="mode === MODE.VIEW"
                      retryText="Thử lại..."
                      retryTitle="Nhấp thử lại"
                      searchPromptText="Nhập để tìm kiếm..."
                      loadingText="Đang tải..."
                      noResultsText="Không có kết quả"
                      openDirection="bottom"
                      @input="updateProductStatus(product.id, $event)"
                    >
                      <label
                        slot="value-label"
                        slot-scope="{ node }"
                        :class="
                          node.raw.value === 1 ? 'text-success' : 'text-danger'
                        "
                      >
                        <b>
                          {{ node.raw.text }}
                        </b>
                      </label>
                    </Treeselect>
                  </td>
                  <td
                    class="text-center"
                    style="width: 12%"
                    v-if="mode !== MODE.VIEW"
                  >
                    <b-button
                      size="sm"
                      variant="danger"
                      class="btn btn-icon"
                      @click="removeProduct(product)"
                      title="Xóa sản phẩm"
                    >
                      <i class="fas fa-trash"></i>
                    </b-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

import { ASYNC_SEARCH } from '@riophae/vue-treeselect';
import { convertPrice } from '@/utils/common';

import productService from '@/core/api/product';
import { LeadModel } from '@/core/models/Lead.model';
import { ProductModel } from '@/core/models';

import * as ENUM from '@/utils/enum';
import * as ENUM_NAME from '@/utils/enum-name';

export default {
  name: 'InterestedProduct',
  components: {
    Treeselect,
  },
  props: {
    leadForm: {
      type: [Object, LeadModel],
      required: true,
    },
    mode: {
      type: String,
      required: false,
      default: ENUM.MODE.VIEW,
    },
    selectedProducts: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      MODE: ENUM.MODE,
      productOptions: [],
      interestStatusOptions: this.getOptions(
        ENUM.PRODUCT_INTEREST_STATUS,
        ENUM_NAME.PRODUCT_INTEREST_STATUS_NAME,
      ),
    };
  },

  computed: {
    selectedProductIds() {
      return this.selectedProducts.map((product) => product.id);
    },
    originalInterestedProducts() {
      return this.leadForm.leadProducts.map((lp) => lp.product.id);
    },
  },

  methods: {
    convertPrice,

    updateField(field, value) {
      this.$emit('update-field', { field, value });
    },

    async onSearchProductChange({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH) {
        await this.searchProducts(searchQuery);
        callback(null, this.productOptions);
      }
    },

    async searchProducts(searchQuery) {
      this.productOptions = [];

      if (!searchQuery) {
        return;
      }

      try {
        const { data } = await productService.searchProducts({
          productName: searchQuery,
          limit: 10,
          isCheckStock: false,
          excludeProductIds: this.originalInterestedProducts,
        });
        const products = ProductModel.fromJsonArray(data?.data) || [];
        this.productOptions = products.map((product) => {
          const productData = {
            id: product.id,
            name: product.name,
            label: product.name,
            sellingPrice: product.sellingPrice,
            code: product.code,
            quantityInStock:
              product.productStock?.reduce(
                (sum, stock) => sum + stock.quantity,
                0,
              ) || 0,
          };

          return productData;
        });
      } catch (error) {
        console.error('Error loading products:', error);
      }
    },

    onSelectProduct(selectedProduct) {
      if (!selectedProduct) return;

      // Check if product is already selected
      const existingProduct = this.selectedProducts.find(
        (product) => product.id === selectedProduct.id,
      );

      if (!existingProduct) {
        const productWithStatus = {
          ...selectedProduct,
          interestStatus: ENUM.PRODUCT_INTEREST_STATUS.INTERESTED, // Default to interested
        };

        const updatedProducts = [...this.selectedProducts, productWithStatus];
        this.$emit('products-updated', updatedProducts);
      }
    },

    onDeselectProduct(deselectedProduct) {
      if (!deselectedProduct) return;

      const updatedProducts = this.selectedProducts.filter(
        (product) => product.id !== deselectedProduct.id,
      );
      this.$emit('products-updated', updatedProducts);
    },

    removeProduct(product) {
      const updatedProducts = this.selectedProducts.filter(
        (item) => item.id !== product.id,
      );
      this.$emit('products-updated', updatedProducts);
    },

    updateProductStatus(productId, status) {
      const updatedProducts = this.selectedProducts.map((product) => {
        if (product.id === productId) {
          return { ...product, interestStatus: status };
        }
        return product;
      });
      this.$emit('products-updated', updatedProducts);
    },

    getOptions(enumValues, enumNames) {
      if (!enumValues || !enumNames) return [];
      if (!Object.values(enumValues).length) return [];

      const options = Object.values(enumValues).map((val) => ({
        value: val,
        text: enumNames[val] || val,
      }));

      return options;
    },

    normalizer(node) {
      return {
        id: node.value,
        label: node.text,
      };
    },
  },
};
</script>

<style lang="scss">
.vue-treeselect__input-container {
  padding-top: 0px;
}

.vue-treeselect__control {
  border-radius: 0.28rem;
  border: 1px solid #ced4da;
  height: 2.5rem;
}

.vue-treeselect--has-value .vue-treeselect__multi-value {
  margin-bottom: 2px;
}

.header-color {
  color: rgb(24, 28, 50);
}

table {
  td {
    vertical-align: middle !important;
  }
}

.required-control label::after {
  content: '*';
  color: red;
}
</style>
